import React, { useContext, useState } from 'react';
import { useParams } from 'react-router-dom';
import { CircularProgress, Grid } from '@material-ui/core';
import { ritzDataContext, selectProjectById } from '@moderepo/mode-data-state-ritz';
import { ITEMS_PER_PAGE_20 } from '@moderepo/mode-app-components';
import { UIFetchIssueFilters } from '@moderepo/mode-data-state-robot-cloud';
import { useRitzTranslation } from '../../utils/customHooks';
import { RCIssuesContainer, IssueTableHiddenFields } from './RCIssuesContainer';



/**
 * Define the list of fields we want to hide in the IssuesTable. This will depends on if there is an issue selected. If there is an issue
 * selected and are showing issue details on the Right side, we can hide some of the unnecessary columns.
 * This will create 2 set of IssueTableHiddenFields. The first set will show more column which should be used when there is no issue selected.
 * The second set has more columns hidden which is to be used when an issue is selected
 */
const issuesTableDisplayHiddenFields: IssueTableHiddenFields = {
    alertId        : true,
    deviceId       : true,
    values         : true,
    ticketLink     : true,
    createdAgentId : true,
    resolvedAt     : true,
    resolvedAgentId: true,
    homeId         : true,
    createdBy      : true,
};



/**
 * This page Display ALL a issues for a Device
 */
export const RCDeviceIssuesPage = () => {
    // Get the params from the route or url
    const params = useParams();
    const projectId = Number(params.projectId);
    const deviceId = Number(params.deviceId);
    const userId = params.userId ? Number(params.userId) : undefined;
    const homeId = params.homeId ? Number(params.homeId) : undefined;

    const { state:dataState } = useContext(ritzDataContext);
    const project = selectProjectById(dataState, projectId);
    const { trans } = useRitzTranslation(project);

    const [issuesTableDisplayFilters] = useState<UIFetchIssueFilters>({ pageNumber: 0, pageSize: 0, deviceId });


    return (
        <div className="page-main-content">
            <div className="title-bar">
                <div className="title-bar-item title-text">
                    <div className="page-title">
                        {trans('page.title.device_issues')}
                    </div>
                    <div className="page-subtitle">
                        {trans('page.subtitle.device_issues')}
                    </div>
                </div>
            </div>

            {project && (
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <RCIssuesContainer
                            projectId={projectId}
                            userId={userId}
                            homeId={homeId}
                            deviceId={deviceId}
                            readonly
                            itemsPerPage={ITEMS_PER_PAGE_20}
                            hiddenFields={issuesTableDisplayHiddenFields}
                            showFilterOptions
                            filters={issuesTableDisplayFilters}
                        />
                    </Grid>
                </Grid>
            )}

            {!project && (
                <CircularProgress />
            )}
        </div>
    );
};
